/**
 * @ngdoc Controller
 * @name RecurringReportsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('RecurringReportsController', RecurringReportsController);

    /**
     * @constructor
     * @ngInject
     */
    function RecurringReportsController(
        $q,
        $log,
        $scope,
        ApiService,
        VrmModalService,
        vrmNotificationsService,
        vrmNotificationType,
        $stateParams,
        moment,
        locale,
        InstallationsService
    ) {
        $log.info('RecurringReportsController');

        $scope.loading = true;
        $scope.mobileView = window.innerWidth < 750;
        angular.element(window).on('resize', _.debounce(function() {
            $scope.mobileView = window.innerWidth < 750;
            $scope.$digest();
        }, 250));

        $scope.$on('$destroy', function() {
            angular.element(window).off('resize');
        });

        $scope.recurringReports = [];
        $scope.hybridReports = [];
        $scope.economicReports = [];
        $scope.reportTemplates = [];

        const redirectUnauthorizedUser = () => {
            InstallationsService.getInstallation($stateParams.id).then(function (installation) {
                if (!installation.view_permissions.update_settings) {
                    InstallationsService.redirectUnauthorizedUser(installation);
                }
            });
        }

        redirectUnauthorizedUser();

        $q.all([
            ApiService.recurringReports($stateParams.id, null, null, 'GET'),
            ApiService.reportTemplates($stateParams.id, null, null, 'GET')
        ]).then(function (response) {
            var recurringReports = response[0].data.recurringReports;
            $scope.reportTemplates = response[1].data.reportTemplates;
            $scope.recurringReports = recurringReports;
            $scope.loading = false;
        }).catch(function (response) {
            // Non-full-access user shouldn't be able to access this page
            if (response.status === 403) {
                redirectUnauthorizedUser();
            }
        });

        $scope.$watchCollection('recurringReports', function (recurringReports) {
            $scope.hybridReports = recurringReports.filter(report => {
                return report.reportTemplates.find(template => {
                    return template.report_type === 'hybrid_genset';
                }) !== undefined;
            })
            $scope.economicReports = recurringReports.filter(report => {
                return report.reportTemplates.find(template => {
                    return template.report_type === 'economic';
                }) !== undefined;
            })
        });

        $scope.deleteReport = function (recReport) {
            VrmModalService.openDeleteModal($scope, 'recurring_report', recReport.name, function (confirmed) {
                if (confirmed) {
                    ApiService.recurringReports($stateParams.id, recReport.idRecurringReport, null, 'DELETE').then(function (res) {
                        if (res.data && res.data.success) {
                            $scope.recurringReports = $scope.recurringReports.filter(function (r) {
                                return (r.idRecurringReport !== recReport.idRecurringReport);
                            });
                            locale.ready('reporting').then(function () {
                                vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('reporting.recurring_report_deleted') });
                            });
                        }
                    });
                }
            });
        }

        $scope.addReport = function () {
            VrmModalService.openRecurringReportModal($scope, null, $scope.reportTemplates, function (save, recurringReport) {
                if (save) {
                    recurringReport.reportTemplates = recurringReport.reportTemplates.map(function (t) {
                       return t.idReportTemplate;
                    });
                    if(recurringReport.endAfter !== undefined) {
                        delete recurringReport.end;
                    } else {
                        recurringReport.end = moment(recurringReport.end).format('YYYY-MM-DD');
                    }
                    recurringReport.start = moment(recurringReport.start).format('YYYY-MM-DD');
                    recurringReport.sendTime = moment(recurringReport.sendTime).format('HH:mm');
                    if(recurringReport.repeatInterval !== 'weekly') {
                        delete recurringReport.weekDays;
                    } else {
                        recurringReport.weekDays = [recurringReport.weekDays];
                    }
                    var report = JSON.parse(JSON.stringify(recurringReport));
                    /*
                        JS is doing some weird things here, which is fixed by copying the object.
                        recurringReport.sendTime first is an object but set to a string a couple of lines above here.
                        For some reason, it is cast back to an object in the callback function.
                        To prevent this, the object is copied.
                     */
                    ApiService.recurringReports($stateParams.id, null, recurringReport, 'POST').then(function (res) {
                        if (res.data && res.data.success) {
                            //Do some formatting
                            report.reportTemplates = report.reportTemplates.map(function (t) {
                                return $scope.reportTemplates.find(function (f) {
                                    return f.idReportTemplate === t;
                                });
                            });
                            report.idRecurringReport = res.data.idRecurringReport;
                            report.reportsSent = 0;
                            $scope.recurringReports.push(report);
                            locale.ready('reporting').then(function () {
                                vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('reporting.recurring_report_added') });
                            });
                        }
                    });
                }
            });
        };
    }

})();
